export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-22 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              关于我们
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              了解YY漫画背后的故事
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/60">
            <div className="space-y-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                <strong className="text-foreground-900 font-bold">YY漫画</strong>诞生于一群漫画爱好者对阅读体验的极致追求。我们发现，虽然网络漫画资源日益丰富，但大多数平台的阅读体验却差强人意——要么图片加载缓慢，要么阅读模式单一，要么界面广告繁杂影响沉浸感。
              </p>
              <p>
                于是，我们打造了YY漫画——一个以<strong className="text-foreground-900 font-bold">阅读体验</strong>为核心的免费漫画平台。我们自主研发了三种阅读模式：<strong className="text-foreground-900">下拉式阅读</strong>让你像刷社交媒体一样流畅看漫画；<strong className="text-foreground-900">弹窗阅读</strong>智能分格，逐格弹出，不遗漏任何细节；<strong className="text-foreground-900">翻页阅读</strong>还原纸质漫画的仪式感。
              </p>
              <p>
                目前YY漫画已收录超过<strong className="text-foreground-900 font-bold">10,000部</strong>漫画作品，涵盖韩漫和日漫的各大热门分类。从热血少年到甜蜜恋爱，从悬疑推理到奇幻异世界，每一位漫画爱好者都能在这里找到属于自己的那部作品。
              </p>
              <p>
                我们坚持<strong className="text-foreground-900 font-bold">免费阅读</strong>的原则，通过合理的广告布局维持平台运营，绝不会让广告干扰你的阅读体验。YY漫画团队将持续优化产品，为你带来更好的漫画阅读之旅。
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mt-10 pt-8 border-t border-background-200/60">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-600">10,000+</div>
                <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-600">3种模式</div>
                <div className="text-xs text-foreground-500 mt-1">阅读方式</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-secondary-600">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">月活读者</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-600">全天候</div>
                <div className="text-xs text-foreground-500 mt-1">稳定服务</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}